import { TableColumn, TableConfig, SORT_ORDER } from "../../../../../@shared/models/table.models";

export const QNA_PAIR_TABLE_COLUMNS: TableColumn[] = [
    {
        field: "question",
        header: "Question",
        type: "custom",
        template: "questionTemplate",
        width: "20%",
        sortable: true
    },
    {
        field: "answer",
        header: "Answer",
        type: "custom",
        template: "answerTemplate",
        width: "30%"
    },
    {
        field: "timesUsed",
        header: "Times Used",
        type: "text",
        width: "10%",
        sortable: true
    },
    {
        field: "author",
        header: "Author",
        type: "custom",
        template: "authorTemplate",
        width: "10%"
    },
    {
        field: "reviewers",
        header: "Reviewed By",
        type: "custom",
        template: "reviewersTemplate",
        width: "10%"
    },
    {
        field: "document",
        header: "Document Name",
        type: "custom",
        template: "documentTemplate",
        width: "10%"
    },
    {
        field: "sourceType",
        header: "Source Type",
        type: "custom",
        template: "sourceTypeTemplate",
        width: "10%"
    },
    {
        field: "lastEdited",
        header: "Last Edited",
        type: "custom",
        template: "lastEditedTemplate",
        width: "10%",
        sortable: true
    }
];

export const QNA_PAIR_TABLE_CONFIG: TableConfig = {
    selectable: true,
    paginator: true,
    rows: 20,
    rowsPerPageOptions: [20, 30, 40],
    scrollable: true,
    scrollHeight: "calc(100vh - 20rem)",
    loading: false,
    emptyMessage: "No Q&A pairs found",
    globalFilter: false,
    responsive: true,
    columnSortingFunction: (field: string, order: SORT_ORDER) => { }
};


